export const navigate = (url, object) => {
    window.f_navigate(url, object)
}